import React, { useState,useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { NavLink, Navigate, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { fetchJob, getJobByType } from '../redux/actions/jobsActions';
import { useLocation } from 'react-router-dom';
import { addApplication } from '../redux/actions/applicationsActions';
import Spinner from 'react-bootstrap/Spinner';
import Arrow from "../images/left-arrow-svgrepo-com.svg"

function JobDetails() {
    const {job,jobsbyType} = useSelector(state=> state.jobsReducer)
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [show, setShow] = useState(false);
    const [candidate,setCandidate] = useState({ name: '', phone: '',email: '',resume: '',reference:'',fileobject:null})
    const [error,setError] = useState({ name: '', phone: '',email: '',resume: '',reference:''})
    const [emailError,setEmailError] = useState("")
    const [addloading,setAddLoading] = useState(false)

    const [loading,setLoading] = useState(false);

    const handleClose = () => {
        setCandidate({ name: '', phone: '',email: '',resume: '',reference:'',fileobject:null})
        setError({ name: '', phone: '',email: '',resume: '',reference:''})
        setShow(false)};
    const handleShow = () => {
        setCandidate({ name: '', phone: '',email: '',resume: '',reference:'',fileobject:null})
        setError({ name: '', phone: '',email: '',resume: '',reference:''})
        setShow(true)};

    useEffect(()=>{
        if(location?.state?.data){
            onFetchData(location?.state?.data)
        }else{
            navigate('/')
        }
    },[location?.state?.data])
    
    const onFetchData = async(data) =>{
        setLoading(true)
        const fromdata = data
        var res;
        if(fromdata?.item?.id){
            res = await dispatch(fetchJob(fromdata.item.id))
            await dispatch(getJobByType(fromdata.item.type,fromdata.item.id))
        }else{
            navigate('/user-dashboard')
        }
        if(res.success){
            setLoading(false);
        }else if(!res.success){
            setLoading(false);
        }
    }

    const newCandidate = async() =>{
        const candidatedata = candidate
        const {name,email,resume,reference,phone,fileobject} = candidate
        const regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let validate = true;
        if(name==''){
            setError((prev) => ({
                ...prev,
                name: "Please Enter Your Name",
            }));
            validate = false
        }
        if(email==''){
            setError((prev) => ({
                ...prev,
                email: "Please Enter Your Email Address",
            }));
            validate = false
        }else if(!regEx.test(email)){
            setError((prev) => ({
                ...prev,
                email: "Email Address is not valid",
            }));
            validate = false
        }
        if(phone==''){
            setError((prev) => ({
                ...prev,
                phone: "Please Enter Your Phone Number",
            }));
            validate = false
        }else if(phone.length!==10){
            setError((prev) => ({
                ...prev,
                phone: "Phone Number must be of 10 digit",
            }));
            validate = false
        }
        if(reference==''){
            setError((prev) => ({
                ...prev,
                reference: "Reference must be required",
            }));
            validate = false
        }
        if(resume=='' || fileobject==null){
            setError((prev) => ({
                ...prev,
                resume: "Please Select Resume File",
            }));
            validate = false
        }
        if(validate){
            candidatedata.status = true
            candidatedata.position = job.position
            setAddLoading(true)
            const res = await dispatch(addApplication(candidatedata))
            if(res.success){
                setCandidate({ name: '', phone: '',email: '',resume: '',reference:'',fileobject:null})
                setShow(false)
            }else if(!res.success){
                if(res.error.code==="23505"){
                    setEmailError("Email Address must be unique")
                }
            }
            setAddLoading(false)
        }
    }

    const onChange = (e) =>{
        const { name, value } = e.target;
        if(name=="resume"){
            let filetype = value.substr(value.lastIndexOf('.'));
            if ((filetype.toLowerCase() != ".docx") &&
            (filetype.toLowerCase() != ".doc") &&
            (filetype.toLowerCase() != ".pdf") &&
            (filetype.toLowerCase() != ".rtf") &&
            (filetype != "")){
                setCandidate((prev) => ({
                    ...prev,
                    [name]: ""
                }));
                setCandidate((prev) => ({
                    ...prev,
                    fileobject: null
                }));
                setError((prev) => ({
                    ...prev,
                    [name]: "File format is not valid",
                }));
                return false
            }else{
                setCandidate((prev) => ({
                    ...prev,
                    [name]: value,
                }));
                setCandidate((prev) => ({
                    ...prev,
                    fileobject: e.target.files[0],
                }));
                setError((prev) => ({
                    ...prev,
                    [name]: '',
                }));
            }
        }else{
            setCandidate((prev) => ({
                ...prev,
                [name]: value,
            }));
            setError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }
    }

    const activeJobsByType = jobsbyType.filter((item)=>{return item.status===true})

    return (
        <div>
        <div className={`main-content navbar-ful`}>
            <div className=''>
                <Container fluid>
                    <Row className='pt-4 d-flex'>
                        {/* Recent Jobs */}
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='pb-2' style={{display:"flex"}}>
                            <NavLink to='/' style={{padding:"0px"}} className='btn'><img className='left-arrow-back' src={Arrow}/></NavLink>
                            <h3 style={{marginLeft:"8px"}}className='mb-0'>Job Details</h3>
                        </Col>
                        {loading ?
                        <div className='load-height spinner'><Spinner animation="grow"/></div>:
                        <>
                        <Col xs="12" sm="12" md="8" lg="8" xl="8" xxl="8" className='mt-3 d-flex'>
                            <div className='job_box_user das3'>
                                <h4 className="text-dark c_name mb-0">{job.position}</h4>
                                <div className="dash-count bill_box das3 user_dash">
                                    <div className="dash-counts">
                                        <h5 className="text-dark text-green">Location :<span>{job.location}</span></h5>
                                        <h5 className="text-dark">Post Date : {new Date(job.created_at).getDate() + '-' +  (new Date(job.created_at).getMonth()+1) + '-' + new Date(job.created_at).getFullYear()}</h5>
                                    </div>
                                    <div className="dash-imgs">
                                    <h5 className="text-dark">Job Type : <span>{job.type}</span></h5>
                                        <h5 className="text-dark">Required Experience : <span>{job.experience}</span></h5>
                                    </div>
                                </div>
                                <div>
                                    <h4 className="text-dark c_name mb-0">Job Description:</h4>
                                    <p className='mt-2' dangerouslySetInnerHTML={{__html: job.description}}></p>
                                </div>
                                {/* <div>
                                    <h4 className="text-dark c_name mb-3">Job Description:</h4>
                                    <ul className='list-text'>
                                        <li>Speak to the clients who Sign up with service on Website and Close the client</li>
                                        <li>Speak to international clients to resolve the technical &amp; product issues on call and chat</li>
                                        <li>Check with clients on a regular basis to ensure that they don’t any issues and if there, issues are resolved in a timely manner.</li>
                                        <li>Provide complete, 360° technical support including via phone, chat and in certain cases, remote screen share.</li>
                                        <li>Provide after-sales support where you will help the client understand how to use the product and resolve any questions or queries that the client might have pertaining to the product/service and explain the usage thoroughly.</li>
                                    </ul>
                                </div> */}
                                <div>
                                    <Button className='btn btn-primary'  onClick={handleShow}>Apply Now</Button>
                                </div>
                                <div>
                                    <hr/>
                                    <h4 className="text-dark c_name mb-3">About Logicode:</h4>
                                    <p>Logicode is a unique competent, professional and creative website development company providing full featured web solution.We have a team of professionals and Expert Web Designers, Web Developers and SEO that gives you appropriate web services based on latest design technology.Our and strict quality standards & extremely non-compromising strategies to help you deliver results that are totally reliable and based on your needs and requirements.</p>

                                    <h4 className="text-dark c_name mb-2">Address:</h4>
                                    <p>1003-Earth Arise, Near YMCA Club,S.G Highway, Ahmedabad, Gujarat 380015</p>
                                    <h4 className="text-dark c_name mb-2">Contact:</h4>
                                    <p className='contact'>Email: <a href='mailto:hr@logicode.in'>hr@logicode.in</a></p>
                                    <p className='contact'>Phone: <a href='tel:079 40306767'>079 40306767</a></p>
                                </div>
                                
                            </div>
                        </Col>

                        <Col xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" className='mt-3'>
                            <div className='job_box das3 w-100'>
                                <h4 className="text-dark c_name mb-0">Related {job.position} Jobs</h4>
                                <hr/>
                                {(!loading && activeJobsByType.length==0)? <p style={{fontSize:"14px"}}>No Related Jobs Available</p>:
                                activeJobsByType.map((item,index)=>{
                                return <div className='releted-job pb-3'>
                                    <h4 className="text-dark c_name mb-3">{item.position}</h4>
                                    <div className='location'>
                                        <h6 className="text-dark c_name mb-2 text-green">Location : <span>{item.location}</span></h6>
                                    </div>

                                    <div className='location mt-3'>
                                        <h6 className="text-dark c_name mb-2">Job Type : <span>{item.type}</span></h6>
                                        <h6 className="text-dark c_name mb-2">Required Experience : <span>{item.experience}</span></h6>
                                    </div>
                                    
                                    <div className='location mt-3'>
                                        <NavLink to='/job-details' state={{ data: { item } }} className='btn btn-primary'>View Details</NavLink>
                                    </div>
                                </div>
                                })}
                                <hr/>
                                <NavLink to='/' className='btn mb-4 view-all'>View All Jobs</NavLink>
                            </div>
                        </Col>
                        </>}
                        {/* Recent Jobs */}
                        <Modal show={show} onHide={handleClose}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Apply For This Job</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form className='mt-1 mb-2'>
                                                    <Row>
                                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                                <Form.Label>Name</Form.Label>
                                                                <Form.Control name="name" value={candidate.name} onChange={(e)=>onChange(e)} type="text" placeholder="Name...." required/>
                                                                {error.name && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.name}</small>}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                                <Form.Label>Phone No</Form.Label>
                                                                <Form.Control name="phone" value={candidate.phone} onChange={(e)=>onChange(e)} type="number" placeholder="Phone No...." required/>
                                                                {error.phone && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.phone}</small>}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                                <Form.Label>Email Address</Form.Label>
                                                                <Form.Control name="email" value={candidate.email} onChange={(e)=>onChange(e)} type="email" placeholder="Email...." required/>
                                                                {error.email && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.email}</small>}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                                <Form.Label>Reference</Form.Label>
                                                                <Form.Control name="reference" value={candidate.reference} onChange={(e)=>onChange(e)} type="text" placeholder="Reference...." required/>
                                                                {error.reference && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.reference}</small>}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                                            <Form.Group className="mb-0" controlId="exampleForm.ControlInput1">
                                                                <Form.Label>Upload Resume</Form.Label>
                                                                <Form.Control name="resume" value={candidate.resume} onChange={(e)=>onChange(e)} type="file" placeholder="file...." required/>
                                                                {error.resume && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.resume}</small>}
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                                {emailError && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{emailError}</small>}
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={handleClose}>
                                                Close
                                            </Button>
                                            <Button variant="primary" onClick={newCandidate} disabled={addloading}>
                                                Submit Application
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                    </Row>

                    <Row className='bg-dark mt-5'>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='mt-3'>
                            <p className='text-white text-center'>2023 © Design by Logicode.</p>
                        </Col>
                    </Row>
            </Container>
            </div>
        </div>
        </div>
    );
}

export default JobDetails;
